import _toConsumableArray from "/builds/gremlin-sandbox/gremlin-sandbox-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _regeneratorRuntime from "/builds/gremlin-sandbox/gremlin-sandbox-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/builds/gremlin-sandbox/gremlin-sandbox-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/builds/gremlin-sandbox/gremlin-sandbox-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/gremlin-sandbox/gremlin-sandbox-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/builds/gremlin-sandbox/gremlin-sandbox-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/builds/gremlin-sandbox/gremlin-sandbox-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/builds/gremlin-sandbox/gremlin-sandbox-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/builds/gremlin-sandbox/gremlin-sandbox-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _extends from "@babel/runtime/helpers/extends";
import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _defineProperty from "@babel/runtime/helpers/defineProperty"; ///////////////////////////////////////////////////////////
// ReflexElement
// By Philippe Leefsma
// December 2016
//
///////////////////////////////////////////////////////////

import ReflexHandle from './ReflexHandle';
import { getDataProps } from './utilities';
import throttle from 'lodash.throttle';
import Measure from 'react-measure';
import PropTypes from 'prop-types';
import React from 'react';

var SizeAwareReflexElement =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SizeAwareReflexElement, _React$Component);

  /////////////////////////////////////////////////////////
  //
  //
  /////////////////////////////////////////////////////////
  function SizeAwareReflexElement(props) {
    var _this;

    _classCallCheck(this, SizeAwareReflexElement);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SizeAwareReflexElement).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "onResize", function (rect) {
      var _this$props = _this.props,
          resizeHeight = _this$props.resizeHeight,
          resizeWidth = _this$props.resizeWidth;
      var height = Math.floor(rect.bounds.height);
      var width = Math.floor(rect.bounds.width);

      _this.setDimensions(_objectSpread({}, resizeHeight && {
        height: height
      }, resizeWidth && {
        width: width
      }));
    });

    _this.setDimensions = throttle(function (dimensions) {
      _this.setState(dimensions);
    }, _this.props.propagateDimensionsRate / 1000);
    _this.state = {
      height: "100%",
      width: "100%"
    };
    return _this;
  } /////////////////////////////////////////////////////////
  //
  //
  /////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////
  //
  //
  /////////////////////////////////////////////////////////


  _createClass(SizeAwareReflexElement, [{
    key: "renderChildren",
    value: function renderChildren() {
      var _this2 = this;

      var propagateDimensions = this.props.propagateDimensions;
      return React.Children.map(this.props.children, function (child) {
        if (_this2.props.withHandle || ReflexHandle.isA(child)) {
          return React.cloneElement(child, _objectSpread({
            dimensions: propagateDimensions && _this2.state
          }, child.props, {
            index: _this2.props.index - 1,
            events: _this2.props.events
          }));
        }

        if (propagateDimensions) {
          return React.cloneElement(child, _objectSpread({}, child.props, {
            dimensions: _this2.state
          }));
        }

        return child;
      });
    } /////////////////////////////////////////////////////////
    //
    //
    /////////////////////////////////////////////////////////

  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return React.createElement(Measure, {
        bounds: true,
        onResize: this.onResize
      }, function (_ref) {
        var measureRef = _ref.measureRef;
        return React.createElement("div", {
          ref: measureRef,
          className: "reflex-size-aware"
        }, React.createElement("div", {
          style: _this3.state
        }, _this3.renderChildren()));
      });
    }
  }]);

  return SizeAwareReflexElement;
}(React.Component);

var ReflexElement =
/*#__PURE__*/
function (_React$Component2) {
  _inherits(ReflexElement, _React$Component2);

  /////////////////////////////////////////////////////////
  //
  //
  /////////////////////////////////////////////////////////
  function ReflexElement(props) {
    var _this4;

    _classCallCheck(this, ReflexElement);

    _this4 = _possibleConstructorReturn(this, _getPrototypeOf(ReflexElement).call(this, props));
    _this4.state = {
      size: props.size
    };
    return _this4;
  } /////////////////////////////////////////////////////////////
  //
  //
  /////////////////////////////////////////////////////////////


  _createClass(ReflexElement, [{
    key: "componentDidUpdate",
    /////////////////////////////////////////////////////////
    //
    //
    /////////////////////////////////////////////////////////
    value: function () {
      var _componentDidUpdate = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(prevProps, prevState, snapshot) {
        var directions, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, direction;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(prevState.size !== this.state.size)) {
                  _context.next = 28;
                  break;
                }

                directions = this.toArray(this.props.direction);
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 5;
                _iterator = directions[Symbol.iterator]();

              case 7:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context.next = 14;
                  break;
                }

                direction = _step.value;
                _context.next = 11;
                return this.props.events.emit('element.size', {
                  index: this.props.index,
                  size: this.props.size,
                  direction: direction
                });

              case 11:
                _iteratorNormalCompletion = true;
                _context.next = 7;
                break;

              case 14:
                _context.next = 20;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context["catch"](5);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 20:
                _context.prev = 20;
                _context.prev = 21;

                if (!_iteratorNormalCompletion && _iterator.return != null) {
                  _iterator.return();
                }

              case 23:
                _context.prev = 23;

                if (!_didIteratorError) {
                  _context.next = 26;
                  break;
                }

                throw _iteratorError;

              case 26:
                return _context.finish(23);

              case 27:
                return _context.finish(20);

              case 28:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[5, 16, 20, 28], [21,, 23, 27]]);
      }));

      function componentDidUpdate(_x, _x2, _x3) {
        return _componentDidUpdate.apply(this, arguments);
      }

      return componentDidUpdate;
    }() /////////////////////////////////////////////////////////
    //
    //
    /////////////////////////////////////////////////////////

  }, {
    key: "toArray",
    value: function toArray(obj) {
      return obj ? Array.isArray(obj) ? obj : [obj] : [];
    } /////////////////////////////////////////////////////////
    //
    //
    /////////////////////////////////////////////////////////

  }, {
    key: "renderChildren",
    value: function renderChildren() {
      var _this5 = this;

      return React.Children.map(this.props.children, function (child) {
        if (_this5.props.withHandle || ReflexHandle.isA(child)) {
          return React.cloneElement(child, _objectSpread({}, child.props, {
            index: _this5.props.index - 1,
            events: _this5.props.events
          }));
        }

        return child;
      });
    } /////////////////////////////////////////////////////////
    //
    //
    /////////////////////////////////////////////////////////

  }, {
    key: "render",
    value: function render() {
      var className = [].concat(_toConsumableArray(this.props.className.split(' ')), [this.props.orientation, 'reflex-element']).join(' ').trim();

      var style = _objectSpread({}, this.props.style, {
        flex: this.props.flex
      });

      return React.createElement("div", _extends({}, getDataProps(this.props), {
        className: className,
        style: style
      }), this.props.propagateDimensions ? React.createElement(SizeAwareReflexElement, this.props) : this.renderChildren());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.size !== prevState.size) {
        return _objectSpread({}, prevState, {
          size: nextProps.size
        });
      }

      return null;
    }
  }]);

  return ReflexElement;
}(React.Component);

export { ReflexElement as default };

_defineProperty(ReflexElement, "propTypes", {
  renderOnResizeRate: PropTypes.number,
  propagateDimensions: PropTypes.bool,
  resizeHeight: PropTypes.bool,
  resizeWidth: PropTypes.bool,
  className: PropTypes.string,
  size: PropTypes.number /////////////////////////////////////////////////////////
  //
  //
  /////////////////////////////////////////////////////////

});

_defineProperty(ReflexElement, "defaultProps", {
  propagateDimensionsRate: 100,
  propagateDimensions: false,
  resizeHeight: true,
  resizeWidth: true,
  direction: [1],
  className: '' /////////////////////////////////////////////////////////
  //
  //
  /////////////////////////////////////////////////////////

});